import * as React from 'react'

const LoadingSpinner: React.FunctionComponent = () => {
  return (
    <div className="loading-section u-space-top-2">
      <span className="loading">
        <span className="spinner" /> Loading&hellip;
      </span>
    </div>
  )
}

export default LoadingSpinner
